import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
import ChaplaincyCertificates from '../components/static/degreePage/degree/chaplaincyCertificate';
import Store from '../store';
import LoginLayout from './../hoc/appLayout'
import {getChaplaincyCertificate} from "../api/chaplaincy_certificates";
const Chaplaincy = (props) => {

  const [isMobile, setIsMobile] = useState(false);
	const { userAuth } = Store.getState();
	const [isLogin, setIsLogin] = useState(false);

  
	useEffect(() => {
		if (userAuth.authenticated && userAuth.token) {
			setIsLogin(true);
		}
		if (window.innerWidth < 767) {
			setIsMobile(true);
		}
	}, []);

    const meta = {
		title: "Certificate in Islamic Chaplaincy |  Bayan",
		description: "BAYAN AFFILIATED FACULTY HAIL FROM PREMIER INSTITUTIONS",
		route: "chaplaincy-certificate",
	}
    return ( 
      <>
      {isLogin ?
				<LoginLayout theme={props.theme} meta={meta}>
          <ChaplaincyCertificates chaplaincyCertificateData={props?.chaplaincyCertificateData}/>
        </LoginLayout>
        :
        <Layout theme={props.theme} meta={meta}>
          <ChaplaincyCertificates chaplaincyCertificateData={props?.chaplaincyCertificateData}/>
        </Layout>
      }
      </>
     );
}

export async function getServerSideProps(ctx) {
	const chaplaincyCertificateData = await getChaplaincyCertificate();
	return { props: { chaplaincyCertificateData: chaplaincyCertificateData?chaplaincyCertificateData:'KS' } }
}
export default Chaplaincy;